import React from 'react';

import { Link } from 'gatsby';
import TagRoundedIcon from '@mui/icons-material/TagRounded';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Chip from '@mui/joy/Chip';

export type TagQuery = BadgeProps & {
  name: string;
  label: string;
  slug: string;
  postCount?: number;
};

const Tag: React.FC<TagQuery> = ({
  name,
  label,
  slug,
  postCount,
  ...badgeProps
}) => {
  return (
    <Badge badgeContent={postCount} color="primary" {...badgeProps}>
      <Chip
        color="primary"
        size="lg"
        component={Link}
        to={slug}
        startDecorator={<TagRoundedIcon />}
        onClick={() => {}}
      >
        {label || name}
      </Chip>
    </Badge>
  );
};

export default Tag;
